
export default {
  props: {
    item: {type: Object, required: true},
    disabled: {type: Boolean, default: false},
  },
  emits: ['edit', 'delete']
}
